module.exports = __webpack_public_path__ + "static/01-14172fbec084d31f46ac538c39fb576d.jpg";